import React 						from 'react';
import ReactDOM 					from 'react-dom';
import BLComponent					from '../core/_BLComponent.jsx';


import InventorySetInfoSection		from './inventorySetInfoSection.jsx';
import InventoryComparisonTitle 	from './inventoryComparisonTitle.jsx';

export default class InventoryLoadingState extends BLComponent
{
	componentDidMount()
	{
		
	}

	render() {
		
		return(
			<React.Fragment>
				<InventoryComparisonTitle/>
				<InventorySetInfoSection data={{isEdit:false, invA: null, invB: null}}/>
				{this.renderLoadingState()}
				
			</React.Fragment>
		)
	}

	renderLoadingState() {
		const {invA, invB, isLoadingDataError} = this.props.data;

		if (!isLoadingDataError) {
			return(
				<div className="l-margin-top--xl text--center">
					<div className="inventory-comparison__loading-spinner l-inline-block" >
						Loading Inventory Data   <span className="l-margin-left--xl"><i className="fas fa-spinner fa-spin"></i></span>
					</div>
				</div>
			)
		}
		else
		{
			return(
				<div className="inventory-comparison__loading-error l-margin-top--xl text--center">
					<div className="text--xxl-title inventory-comparison__error-msg-color">
						<i className="fas fa-exclamation-triangle"></i>
					</div>
					<div className="text--title"><strong>Error loading data</strong></div>
					<div className="inventory-comparison__text--light">
					{ invA.isError && this.renderErrorMsg(invA, 0) }
					{ invB.isError && this.renderErrorMsg(invB, 1) }
					
					<div><button className="btn--link text--small-title" onClick={()=>this.props.func.backToLanding()}><strong>Go Back</strong></button></div>
					</div>
				</div>
			)
		}

	}

	renderErrorMsg(inv, invSection) {
		const source = inv.source;
		const setId = inv.setId;
		const setSeq = inv.setSeq;
		const bBrickLinkErrorWithoutSeq = ((source == "BrickLink") && (setSeq == "") )?true:false;
		const args = this.getCollectedURL(invSection);
		const url = window.location.pathname + "?" + args;
		return (
			<div>
			{ (inv.source == "BrickLink")?"BrickLink":"LEGO" } Inventory data for <strong>{inv.setId + ( (inv.setSeq != "")? "-"+inv.setSeq:"" )}</strong> is unavailable.
			{bBrickLinkErrorWithoutSeq && 
				<div>
					Did you mean <button className="btn--link" onClick={() => window.location=url }><strong>{setId}-1</strong></button>? 
				</div>
			} 
			</div>
		)
	}

	getCollectedURL( invSection ) {
		const {invA, invB} = this.props.data;

		const strArgSourceA = "sourceA=" + ( (invA.source == "BrickLink")?"0":"1" );
		const strArgSetA = "invA=" + invA.setId;
		const strArgSetSeqA = (invA.setSeq != "" )?"-" + invA.setSeq:(invA.source == "BrickLink")?"-1":"";

		const strArgSourceB = "sourceB=" + ( (invB.source == "BrickLink")?"0":"1" );
		const strArgSetB = "invB=" + invB.setId;
		const strArgSetSeqB = (invB.setSeq != "" )?"-" + invB.setSeq:(invB.source == "BrickLink")?"-1":"";

		if (invSection == 0) {
			return strArgSourceA + "&" + strArgSetA + strArgSetSeqA + "&" + strArgSourceB + "&invB=" + invB.setId + ( ( invB.setSeq != "" )?"-" + invB.setSeq:"" );
		}
		else {
			return strArgSourceA + "&invA=" + invA.setId + ( ( invA.setSeq != "" )?"-" + invA.setSeq:"" )  + "&" + strArgSourceB + "&" + strArgSetB + strArgSetSeqB;
		}
	}
}